import { ApiExportFormat } from "@/types/analytics/analytics.types.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";

export interface ApiTimeEntry {
  id: number;
  employee_id: number;
  datetime_clocked_in: Date;
  datetime_clocked_out: Date | null;
  clock_in_comment: string | null;
  clock_out_comment: string | null;
  is_edited: boolean;
  edited_by: number | null;
  datetime_edited_at: Date | null;
  edit_reason: string | null;
  is_active: boolean;
}

export interface ApiTimeTrackingStatus {
  is_clocked_in: boolean;
  current_entry: ApiTimeEntry | null;
}

export interface ApiTimeEntryFilter {
  page_number?: number;
  date_period_start?: Date | null;
  date_period_end?: Date | null;
}

export interface ApiTimeEntrySaveInput {
  datetime_clocked_in?: Date | null;
  datetime_clocked_out?: Date | null;
  clock_in_comment?: string | null;
  clock_out_comment?: string | null;
  edit_reason?: string | null;
}

export interface ApiTimesheetDay {
  date_day: Date;
  duration_minutes: number;
  has_active: boolean;
  entries: ApiTimeEntry[];
}

export interface ApiTimesheetRow {
  employee: ApiEmployee;
  total_minutes: number;
  days: ApiTimesheetDay[];
  active_entry: ApiTimeEntry | null;
}

export enum ApiTimesheetEmployeeScope {
  active = "active",
  with_entries = "with_entries",
  all = "all",
}

export interface ApiTimesheetFilter extends ApiFilterBase {
  date_period_start: Date;
  date_period_end: Date;
  text?: string | null;
  page_number?: number;
  employee_scope?: ApiTimesheetEmployeeScope;
  format?: ApiExportFormat;
}

export enum ApiTimesheetExportLayout {
  summary = "summary",
  detailed = "detailed",
}

export interface ApiTimesheetExportFilter extends ApiTimesheetFilter {
  format: ApiExportFormat.xlsx;
  layout: ApiTimesheetExportLayout;
}
